import { errorToast } from "@/v2-ui/toast"
import Selector from "@/v2-backoffice-client/components/selector"
import type { SelectorItemProps } from "@/v2-backoffice-client/components/selector"
import { useLayerCategoryLayerAddMutation } from "@/v2-backoffice-client/layer/category/layer/add/layer.category.layer.add.mutation"
import type { LayerCategoryFragment } from "@/v2-backoffice-client/layer/category/__types__/layer.category.fragment"

export type LayerCategoryLayerAddSelectorItemProps = Omit<
  SelectorItemProps,
  "value" | "children" | "onSelect"
> & {
  category: LayerCategoryFragment
  layerFeatureCode: string
  onSelect?(): void
}

function LayerCategoryLayerAddSelectorItem(
  props: LayerCategoryLayerAddSelectorItemProps,
) {
  const { category, layerFeatureCode, onSelect, ...selectorItemProps } = props

  const [select, { loading, error }] = useLayerCategoryLayerAddMutation()
  errorToast(error, {
    title: "Failed to add layer to category",
  })

  return (
    <Selector.Item
      isLoading={loading}
      value={`${category.Name ?? category.FeatureCode} ${category.FeatureCode}`}
      onSelect={() => {
        select({
          variables: {
            layerFeatureCode,
            categoryFeatureCode: category.FeatureCode,
          },
        })
        onSelect?.()
      }}
      {...selectorItemProps}
    >
      <Selector.ItemText
        primary={category.Name ?? category.FeatureCode}
        secondary={category.FeatureCode}
      />
    </Selector.Item>
  )
}

export default LayerCategoryLayerAddSelectorItem
